import { Cell, Pie, PieChart } from 'recharts';
import { useTranslation } from "react-i18next";

interface CommentPieCardProps {
  commentType: string;
  label: string;
  percentage: number;
  comments: number;
  totalComments: number;
  color: string;
}

export default function CommentPieCard({ commentType, percentage, comments, totalComments, label, color }: CommentPieCardProps) {
  const PecentageToDegrees = Math.round((percentage / 100) * 360)
  const { t } = useTranslation('dashboard');
  return (
    <>

          <p style={{ fontWeight: 600 }}>{label}</p>
      <PieChart width={200} height={200}>
        <Pie
          data={[{ name: commentType, value: PecentageToDegrees }, { name: "other", value: 360 - PecentageToDegrees }]}
          dataKey="value"
          nameKey="name"
          innerRadius={65}
          outerRadius={90}
          startAngle={90}
          endAngle={-450}
          fill={"#D9D9D9"} >
          <Cell key={`cell`} fill={color} />
        </Pie>
        <text x={"50%"} y={"50%"} dy={8} textAnchor="middle" fill={"black"} style={{ fontWeight: "700", fontSize: "28" }}>
          {Math.round(percentage)}%
          </text>
      </PieChart>
          <p className="m-0">{comments} {label}</p>
          <p className="m-0">{t("dashboard:feelingAnalysis.commentsPie", { numberOfSurveys: totalComments })}</p>
    </>
  );
}